module.exports = __webpack_public_path__ + "img/WIFI.e2dac4c6.png";